import React, { Component } from 'react'
import { Action } from 'hljd'
import { observer, inject } from 'mobx-react'
import { isWeddingDressProperty } from '@merchant-backend/util'
const Item = Action.Item

@inject('store')
@observer
export default class extends Component {
  render() {
    const { tab, changTab } = this.props.store
    return (
      <Action active={tab} onChange={changTab}>
        <Item value="0">
          <span>套餐数据</span>
        </Item>
        {isWeddingDressProperty() ? (
          <Item value="2">
            <span>款式数据</span>
          </Item>
        ) : (
          <Item value="1">
            <span>案例数据</span>
          </Item>
        )}
      </Action>
    )
  }
}
